<template>
  <Modal v-if="visible" :value="true" @input="closeModal" width="lg">
    <span slot="header">
      Exportar relatório
    </span>

    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <p>
            Total de multas selecionadas: <strong>{{ total }}</strong>
          </p>
        </div>
      </div>

      <p>Colunas adicionais:</p>
      <div class="row">
        <div class="d-flex col-md justify-content-between">
          <span><input v-model="linkBoleto" type="checkbox"> Link do boleto</span>
          <span><input v-model="linkFici" type="checkbox"> Link do FICI</span>
          <span><input v-model="linkDemonstrativo" type="checkbox"> Link do demonstrativo</span>
          <span><input v-model="linkNotification" type="checkbox"> Link da notificação</span>
        </div>
      </div>

      <hr>
      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn btn-outline mr-2" @click="closeModal">Cancelar</button>
          <button class="btn btn-primary" @click="toXLSX">Exportar multas</button>
        </div>
      </div>
    </div>

  </Modal>
</template>

<script>
import GlobalLoading from '@/mixins/GlobalLoading'
import Modal from '@/components/shares/specialTag/Modal'

export default {
  components: { Modal },
  computed: {
    visible() {
      return this.value
    }
  },
  data: () => ({
    value: false,
    total: 0,
    params: null,
    linkBoleto: false,
    linkFici: false,
    linkDemonstrativo: false,
    linkNotification: false,
    allowCrossing: false,
  }),
  methods: {
    requestReport(params, total, allowCrossing) {
      this.params = params
      this.total = total
      this.value = true
      this.allowCrossing = allowCrossing
    },
    toXLSX() {
      this.value = false
      const params = this.params
      if (this.linkBoleto)
        params['methods'].push('link_boleto')
      if (this.linkFici)
        params['methods'].push('link_fici')
      if (this.linkDemonstrativo)
        params['methods'].push('link_demonstrativo')
      if (this.linkNotification)
        params['methods'].push('link_notification')
      if (this.allowCrossing)
        params['methods'].push('driver')

      this.openGlobalLoad()
      this.axios.get('maestro/tickets/report', {params})
        .then(response => {
          if (response.data)
            this.$parse.downloadByLink(response.data)
          else
            this.$notify.add(response.meta.notice)
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    closeModal() {
      this.value = false
    },
  },
  mixins: [GlobalLoading],
  name: 'Report'
}
</script>

<style scoped>
.content {
  color: black;
}

.row span {
  display: flex;
  align-items: center;
}

.row span input[type="checkbox"] {
  margin-right: 8px;
}
</style>
